import { NCacheKeyStatus } from "../enums/quotation.enum";
import { CloudVendorType } from "../paid-subscription/types/cloud-vendor.type";
import { BillingTerm, SubscriptionStatusType } from "../types/subscription.type";

export interface NCacheSubscription {
    id?: string
    alAccountId?: number
    status?: SubscriptionStatusType;
    vendor?: CloudVendorType | Lowercase<CloudVendorType>
    planTitle?: string
    planEdition?: string
    userCompany?: string
    period?: string
    startTime:string
    endTime:string
    billingTerm:BillingTerm;
    support247Enabled:boolean;
    planType: string;
    ncacheKeys: LicenseKeyDetails[];
}

export interface LicenseKeyDetails {
    key: string;
    version: string;
    isTrail: boolean;
    versionDisplayName: string;
    keyStatus: NCacheKeyStatus;
    expiry: string;
    extensionKey?: string;
}

export interface Enable24x7Request {
    subscriptionId:string,
    enable24x7:boolean
}

export interface Subscription {
    id?: string;
    vendorName?: CloudVendorType;
    status?: SubscriptionStatusType;
}

export interface CreateSubscriptionRequest {
    marketPlaceToken: string;
    cloudVendor: string;
    authCode: string;
}

export interface CreateLicenseKeyRequest{
    
  subscriptionId: string;
  licensingVersion: string;
  startDate: string;   // formatted as Year-Month-Day
  endDate: string;     // formatted as Year-Month-Day
  userEmail: string;
  customerName: string;
  jobTitle: string;
  companyName: string;
  phone: string;
  contactPers: string;
  url: string;
  city: string;
  country: string;
  state: string;
  licenseEnv: string;
  autoRenew: string;
  isServerOnly: string;
  gracePeriod: string;
}

export interface TrialEmailsRequest {
    userEmail: string;
    nCacheSubscriptionId: string;
    vendor: string;
  }
  

export interface CreateSubscriptionResponse extends Pick<Subscription, "id"> { }

export interface PendingSubscription {
    id: string;
    name: string;
}

export interface SubscriptionNCacheVersion {
    versionName: string;
    versionNumber: string;
    displayName: string;
    productId: string;
    editionId: string;
}

export interface UserSubscription {
    id: string;
    subscriptionName: string;
    vendor: string;
    status: SubscriptionStatusType;
}

export type UserSubscriptionResponse = {
    [vendor in CloudVendorType | Lowercase<CloudVendorType>]?: UserSubscription[];
};

export class SubscriptionItem {
    subscriptionName: string;
    subscriptionId: string;
    vendor: string;
    isPending: boolean = false;
    isDisabled: boolean = false;
    isSelected: boolean = false;

    constructor(subscriptionName: string, subscriptionId: string, vendor: string, isDisabled: boolean = false, isSelected: boolean = false, isPending: boolean = false) {
        this.subscriptionName = subscriptionName;
        this.subscriptionId = subscriptionId;
        this.vendor = vendor;
        this.isDisabled = isDisabled;
        this.isSelected = isSelected;
        this.isPending = isPending;
    }
}